import { CalendarDays, X } from '@tamagui/lucide-icons';
import { Button } from '@unistocks/components/button/button';
import { DatePicker } from '@unistocks/components/date-picker/date-picker/date-picker';
import type { DatePickerPopoverRef } from '@unistocks/components/date-picker/date-picker/date-picker-popover';
import { DatePickerInputProps } from '@unistocks/components/date-picker/date-picker/types';
import { Input } from '@unistocks/components/input/input';
import { formatDate } from '@unistocks/localization';
import { webCursor } from '@unistocks/shared/utils/web-cursor';
import React from 'react';

export const DatePickerInput: React.FC<DatePickerInputProps> = ({
  id,
  placeholder,
  value,
  ref,
  onPress,
  onFocus,
  onClear,
  invalid,
  disabled,
  required,
  ...props
}) => {
  const displayDate = value ? formatDate(value) : placeholder;
  const canClear = !!onClear && !!value && !required;

  /* useEffect(() => {
    if (!id || isDisabled) return;

    return registerFocusable(id, {
      focus: () => onFocus?.()
    });
  }, [id, isDisabled, onFocus]); */

  return (
    <DatePicker ref={ref as React.Ref<DatePickerPopoverRef>} {...props}>
      <Input
        id={id}
        readOnly
        value={displayDate}
        invalid={invalid}
        required={required}
        disabled={disabled}
        userSelect="none"
        {...(disabled ? {} : webCursor('pointer'))}
        onPress={onPress}
        onFocus={onFocus}
        renderRight={
          <Button
            withScale={false}
            size={'$5'}
            theme={'unistocksAlt'}
            px={'$4'}
            disabled={disabled}
            onPress={
              canClear
                ? e => {
                    e.stopPropagation();
                    onClear();
                  }
                : onPress
            }
          >
            <Button.Icon>
              {canClear ? <X color={'$danger'} strokeWidth={4} /> : <CalendarDays />}
            </Button.Icon>
          </Button>
        }
      />
    </DatePicker>
  );
};

DatePickerInput.displayName = 'DatepickerTrigger';
